/// //////////////////////////////////////////////////////////////////////////
//                                                                          //
//  本文件由WIDE自动生成框架，用来定义类似webcomponent的元素．                     //
//  本文件用于定义元素类。                                                     //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// //////////////////////////////////////////////////////////////////////////
// Created At : 2019-01-12T13:46:59.211Z

import grapesjs from './grapesjs'
import constVars from './bs4/consts'

const STOREWRITE = 'data-storewrite'

function deepClone (object) {
  let _ = window._
  var clone = _.clone(object)

  _.each(clone, function (value, key) {
    if (_.isObject(value)) {
      clone[key] = deepClone(value)
    }
  })
  return clone
};

/**
支持web页编辑的元素。这是一个集成元素，依赖了其它几个元素。
- assetViewer: 显示资源的元素。
- codeEditor: 代码编辑元素。
- koraml: 通过raml来定义ko变量的元素。
支持如下属性:
- data-storeread: 获取endpoint. 变动会触发读取。
- data-storewrite: 保存endpoint. 普通属性。
@class Webeditor
@extends wwjs.wwclass
*/
// wwjs.wwclass.dep([])
class Webeditor extends wwjs.wwclass {
  static version = '<# VERSION #>'
  constructor (ele) {
    super(ele)
    // console.log(123123)
    let self = this
    self.layers = {}
    self.layers[constVars.mainLayerName] = {}
    self.editorLoaded = false
    self.watch('data-storeread', { noSyncEle: true, noSyncKO: true })
    // 默认数据首次需要从服务器加载。
    self.syncFlag = true
    self.$ele.css({ 'width': '100%',
      'height': '100%',
      'position': 'fixed'
    })
    // 这里写自己的初始代码，例如需要关注那些属性．
    // 如果不需要构造函数，请删除本函数．
  }

  // webeditor是一个异步初始化元素，需要使用init来指示元素真正的初始化完毕状态。
  init () {
    return grapesjs.init(this)
  }

  finalize () {
    // 这里写自己的析构代码
  }

  /**
  data-storeread属性变动的处理函数.
  @method onstorereadChanged
  @memberof Webeditor
  */
  onstorereadChanged (oldValue, newValue) {
    let self = this
    if (newValue && self.editorLoaded) { // 触发一次加载。
      grapesjs.switchTo(self, constVars.mainLayerName, true, true, true)
    }
  }

  /**
  设置后续的读写操作，是否从服务器中同步。
  @method setSyncFlag
  @param {boolean} [flag = false] 设置为true时，从服务器加载，否则只是本地操作。
  @param {string} commitcontent 本参数用于提交服务器时，指示是否执行一次commit操作，以及commit的注释。
  @memberof Webeditor
  @access private
  */
  setSyncFlag (flag, commitcontent) {
    let oldFlag = this.syncFlag
    this.syncFlag = flag || false
    this.commitcontent = undefined
    if (typeof commitcontent === 'string') {
      this.commitcontent = commitcontent.trim()
    }
    return oldFlag
  }

  /**
  将当前的数据同步——根据是否同步到服务器的标志来决定是否同步到服务器，否则仅仅同步到内存。
  @method load
  @memberof Webeditor
  @param {Function} clb 从服务器加载完毕之后的回调函数。
  @access private
  */
  load (clb) {
    let self = this
    if (self.syncFlag && self.props.storeread) {
      // const api = window.ky.extend({ prefixUrl: 'http://cn.wware.org' })
      const api = window.ky
      api.get(self.props.storeread,
        {
          // headers: { 'cookie': 'sid=s%3AdgEy-NOFAPzU7TxXSe5mZ5otijKMGvIY.fpiNxbAc3U6GqdSSRnRUNNPLkXirBdTkcl%2Biu18nG2w; sid=s%3ADuJxp8ZwrvZ7uDCrFSHWClCqTsVhH5y0.V6iM85kMucXLJPeKyCPSiPJLmen17Ghh4RJUzcXK9W8' },
          // mode: 'no-cors',
          // // cache: 'default',
          // credentials: 'include'
        }).json().then(function (layers) {
        // console.log(response)
        // if(data.version && data.version > 1.0){}
        // load from network.
        // for each html: parallel run : grapesjs.loadDep(self,content)
        // if (Array.isArray(layers)) {
        self.layers = layers
        self.layers[constVars.mainLayerName] = self.layers[constVars.mainLayerName] || {}
        let depTasks = []
        window._.each(self.layers, function (v, k) {
          if (v['gjs-html']) {
            let task = grapesjs.loadDep(self, v['gjs-html'])
            depTasks.push(task)
          }
        })
        // @TODO 是否应该支持css的依赖分析?
        Promise.all(depTasks).then(function () {
          clb()
        }).catch(function (err) {
          clb(err)
        })
        // }
      }).catch(function (err) {
        console.log(err)
        clb(err)
      })
    } else {
      clb()
    }
  }

  /**
  将当前的数据同步——根据是否同步到服务器的标志来决定是否同步到服务器，否则仅仅同步到内存。
  @method store
  @param {Function} clb 保存完毕之后的回调函数
  @memberof Webeditor
  @access private
  */
  store (clb) {
    let self = this
    let storewriteURL = self.$ele.attr(STOREWRITE)
    if (self.syncFlag && storewriteURL) {
      // 保存到网络。
      let formData = new FormData()
      formData.append('layers', new Blob([JSON.stringify(this.layers)]), 'layers.json')
      if (typeof this.commitcontent === 'string' && this.commitcontent.length > 0) {
        formData.append('commit', this.commitcontent)
      }
      window.ky.post(storewriteURL, {
        url: storewriteURL,
        // crossDomain: false,
        body: formData
        // credentials: 'include'
      }).json().then(function (data) {
        console.log(data)
        if (data.success) {
          clb()
        } else {
          clb(data)
        }
      }).catch(function (err) {
        clb(err)
      })
    } else {
      clb()
    }
  }

  /**
  检查当前编辑的内容中，是否存在指定名称的层.
  @method hasLayer
  @param {string} name 层的名称
  @return {boolean} true指示指定层存在
  @memberof Webeditor
  @access private
  */
  hasLayer (name) {
    return this.layers.hasOwnProperty(name)
  }
  /**
  更新指定层的内容，如果层不存在，则新建此层。
  @method updateLayer
  @param {string} name 层的名称
  @param {string} [content=""] 层的内容
  @param {boolean} [bDeepClone=false] 是否深度克隆
  @memberof Webeditor
  @access private
  */
  updateLayer (name, content, bDeepClone) {
    let value = content || {}
    if (bDeepClone) {
      value = deepClone(value)
    }
    this.layers[name] = value
  }

  /**
  删除指定的层
  @method removeLayer
  @param {string} name 层的名称
  @memberof Webeditor
  @access private
  */
  removeLayer (name) {
    if (this.hasLayer(name)) {
      delete this.layers[name]
    }
  }
  /**
  修改指定的层名
  @method renameLayer
  @param {string} oldname 原层的名称
  @param {string} newname 新层的名称
  @param {boolean} [bCopy=false] 是否启用拷贝模式
  @memberof Webeditor
  @access private
  */
  renameLayer (oldname, newname, bCopy) {
    let self = this
    if (!self.hasLayer(oldname)) {
      return false
    }
    self.updateLayer(newname, self.getLayers(oldname), bCopy)
    if (!bCopy) {
      self.removeLayer(oldname)
    }
    return true
  }
  /**
  删除指定的层
  @method updateLayer
  @param {string} [name=undefined] 层的名称,如果未指定，则返回当前的层。
  @memberof Webeditor
  @access private
  */
  currentLayer (name) {
    let old = this._currentLayer || constVars.mainLayerName
    if (name) {
      if (!this.hasLayer(name)) {
        this.layers[name] = {}
      }
      this._currentLayer = name
    }
    return old
  }
  /**
  获取指定的层。
  @method updateLayer
  @param {string} [name=undefined] 层的名称，如果传入空值，则返回全部层。
  @return {string|object<string,string>} 返回指定层的内容或全部层的数据。
  @memberof Webeditor
  @access private
  */
  getLayers (name) {
    return name ? this.layers[name] : this.layers
  }
}

export default Webeditor
